import { render, staticRenderFns } from "./SelectRepair.vue?vue&type=template&id=230a9275&scoped=true"
import script from "./SelectRepair.vue?vue&type=script&lang=js"
export * from "./SelectRepair.vue?vue&type=script&lang=js"
import style0 from "./SelectRepair.vue?vue&type=style&index=0&id=230a9275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a9275",
  null
  
)

export default component.exports